export enum BREAKPOINTS {
    desktopLarge = "1920px",
    desktop = "1440px",
    tablet = "1024px",
    miniTablet = "800px",
    middle = "768px",
    smallTablet = "600px",
    mobile = "500px",
}
